import { render, staticRenderFns } from "./CustomScroll.vue?vue&type=template&id=238c9168&scoped=true&"
import script from "./CustomScroll.vue?vue&type=script&lang=js&"
export * from "./CustomScroll.vue?vue&type=script&lang=js&"
import style0 from "./CustomScroll.vue?vue&type=style&index=0&id=238c9168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c9168",
  null
  
)

export default component.exports